/**
 * Faz o parsing de um texto vCard (.vcf) e extrai as principais informações.
 *
 * @param {string} vcard - Texto do vCard recebido (geralmente vindo de uma mensagem).
 * @returns {{ name: string, phone: string, photo: string }} Objeto contendo nome, telefone e foto em base64 (se houver).
 *
 * @example
 * const data = parseVCard("BEGIN:VCARD\nFN:John Doe\nTEL:+5511999999999\nEND:VCARD")
 * // { name: "John Doe", phone: "+5511999999999", photo: "" }
 */

const parseVCard = (vcard) => {
  if (!vcard || typeof vcard !== "string") {
    return { name: "Unknown", number: "Unknown", photo: "" }
  }

  const nameMatch = vcard.match(/FN:(.*)/i)
  const phoneMatch = vcard.match(/TEL[^:]*:([^\n]+)/i)
  const photoMatch = vcard.match(/PHOTO;(?:BASE64|ENCODING=BASE64):([\s\S]+?)(?:\n[A-Z]|$)/i)

  const name = nameMatch?.[1]?.trim() || "Unknown"
  const number = phoneMatch?.[1]?.replace(/\s+/g, "").trim() || "Unknown"
  const photo = photoMatch?.[1]?.trim() || ""

  return { name, number, photo }
}

export default parseVCard
